import { useCallback, useMemo } from 'react';
import { useAppScopeStore } from '@frontend/scope';
import { usePreference } from '@frontend/user-preferences';
import { createDefaultVoicemailFilters } from '../components/voicemails/voicemail-filters';
import { VoicemailFiltersType } from './use-phone-config-state-store';

export const useVoicemailFilters = (sipId?: string) => {
  const { selectedOrgId } = useAppScopeStore();
  const [storedFiltersMap, setStoredFiltersMap] = usePreference('VoicemailFilters');

  const storedFilters = storedFiltersMap?.[selectedOrgId];

  const filters = useMemo(() => createDefaultVoicemailFilters(sipId, storedFilters), [sipId, storedFilters]);

  const setFilters = useCallback(
    (nextFilters: VoicemailFiltersType) => {
      setStoredFiltersMap({ ...storedFiltersMap, [selectedOrgId]: nextFilters });
    },
    [selectedOrgId, setStoredFiltersMap, storedFiltersMap]
  );

  return {
    filters,
    setFilters,
  };
};
